import request from "@/router/axios";

/**
 * 地点搜索
 * @param name
 * @param city
 * @returns {*}
 */
export function placeSearch(name,city) {
    return request({
        url: '/wayz/search',
        method: 'GET',
        params: {
            name:name,
            city:city
        }
    });
}

/**
 * 天地地图路线规划
 * @param from
 * @param to
 * @param waypoints
 * @returns {AxiosPromise}
 */
export function directionTdMap(from,to,waypoints) {
    return request({
        url: '/direction',
        method: 'GET',
        params: {
            from: from,
            to: to,
            waypoints: waypoints
        }
    });
}
